import React from 'react'

import { Card, Icon, Image } from 'semantic-ui-react'

import { NormalHeader, ReviewsCardFooter, Carousel, CustomCard } from './style'

import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

const reviews = [{
        text: 'Северный (Арктический) федеральный университет имени М.В.Ломоносова',
        img: 'review10.png',
        href: 'node/1489'
    },
    {
        text: 'Тверской государственный технический университет',
        img: 'review9.png',
        href: 'node/1488'
    },
    {
        text: 'Сочинский государственный университет',
        img: 'review8.png',
        href: 'node/1493'
    },
    {
        text: 'Кыргызско-Российский Славянский университет имени Б.Н.Ельцина',
        img: 'review4.png',
        href: 'node/1487'
    },
    {
        text: 'Сибирский университет потребительской кооперации',
        img: 'review7.png',
        href: 'node/1485'
    },
    {
        text: 'Новосибирский государственный университет экономики и управления',
        img: 'review5.png',
        href: 'node/1486'
    },
    {
        text: 'Белорусско-Российский университет',
        img: 'review11.png',
        href: 'node/1497'
    },
    {
        text: 'Выксунский филиал Национального исследовательского технологического университета МИСиС',
        img: 'review2.png',
        href: 'node/1490'
    },
    {
        text: 'Газпром техникум Новый Уренгой',
        img: 'review3.png',
        href: 'node/1491'
    },
    {
        text: 'Пермский техникум промышленных и информационных технологий им.Б.Г.Изгагина',
        img: 'review6.png',
        href: 'node/1492'
    },
    {
        text: 'Березниковский филиала Пермского национального исследовательского политехнического университета',
        img: 'review12.png',
        href: 'node/1501'
    }
]

export const Reviews = ({ primaryColor }) => {
    const items = reviews.map(({ img, text, href }, id) => (
        <CustomCard fluid href={href}>
            <Card.Header>
                <Image centered src="themes/defaultNiimko/images/new/icons/reviews/review1.png"/>
            </Card.Header>
            <Card.Content textAlign="center">
                <b>{text}</b>
            </Card.Content>
            <ReviewsCardFooter>
                <Image centered src={`themes/defaultNiimko/images/new/icons/reviews/${img}`}/>
            </ReviewsCardFooter>
        </CustomCard>
    ));
    const responsive = {
        0: { items: 1 },
        568: { items: 2 },
        1024: { items: 3 },
    };
    const renderPrevButton = ({ isDisabled = false }) => <Icon name="angle left" disabled={isDisabled} />
    const renderNextButton = ({ isDisabled = false }) => <Icon name="angle right" disabled={isDisabled} />

    return (<>
        <NormalHeader as="h3">Успешный опыт участия</NormalHeader>
        <Carousel>
            <AliceCarousel
                autoPlay 
                autoPlayInterval={10000} 
                responsive={responsive} 
                items={items} 
                renderPrevButton={renderPrevButton}
                renderNextButton={renderNextButton}
            />
        </Carousel>
    </>)
}